/*
 * @Author: your name
 * @Date: 2020-12-09 18:21:02
 * @LastEditTime: 2021-01-20 14:17:02
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \bank-activity-admin\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    root: {},
    userInfo: {},
    navBar: {},
    footerText: '乐刷科技有限公司   客服热线：0755-26339288',
    visitedViews: JSON.parse(sessionStorage.getItem('visitedViews')) || []
  },
  mutations: {
    updateRoot (state, root) {
      if (JSON.stringify(root) === '{}') {
        state.root = root
      } else {
        const navList = state.navBar
        navList.length > 0 && navList.map(item => {
          this.commit('saveRoot', item)
        })
      }
    },
    updateUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    updateNavBar (state, navBar) {
      state.navBar = navBar
    },
    saveRoot (state, value) {
      if (value.router) {
        const root = state.root
        const keyList = value.router.split('/')
        let key = keyList[keyList.length - 1]
        if (value.router === '/') {
          key = 'index'
        }
        if (!root[key]) {
          root[key] = value.handler || 1
        } else {
          console.log('路由名称重复，请检查')
        }
        state.root = root
      }
      if (value.children && value.children.length > 0) {
        value.children.map(item => {
          this.commit('saveRoot', item)
        })
      }
    },
    ADD_VISITED_VIEWS: (state, view) => {
      state.visitedViews.forEach(item => {
        if (item.path === view.path) {
          item.query = view.query
        }
      })
      if (state.visitedViews.some(v => v.path === view.path)) return

      // 风控工单 id问题
      if (view.params.Id && state.visitedViews.some(v => v.path.indexOf(view.path.replace(view.params.Id, '')) >= 0)) return
      state.visitedViews.push({
        name: view.name,
        path: view.path,
        title: view.meta.title || 'no-name',
        query: view.query
      })
      sessionStorage.setItem('visitedViews', JSON.stringify(state.visitedViews))
    },
    DEL_VISITED_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
      sessionStorage.setItem('visitedViews', JSON.stringify(state.visitedViews))
    }
  },
  actions: {
    getUserInfo ({ commit }) {
      const envType = process.env.NODE_ENV === 'production' && process.env.CUSTOM_ENV === 'prd' ? 0 : 1
      return new Promise((resolve, reject) => {
        Vue.prototype.$axios.get(Vue.prototype.$api.getUserInfo, {
          params: {
            FMenuSetting: envType
          }
        }).then(res => {
          resolve()
          if (res.respCode === '0') {
            localStorage.setItem('userInfo', JSON.stringify(res.userInfo))
            localStorage.setItem('navBar', JSON.stringify(res.navBar))
            commit('updateUserInfo', res.userInfo)
            commit('updateNavBar', res.navBar)
            commit('updateRoot')
            this.$router.push('/')
          }
        }).catch(e => {
          reject(e)
        })
      })
    },
    addVisitedViews ({ commit }, view) {
      console.log('view: ', view)
      commit('ADD_VISITED_VIEWS', view)
    },
    delVisitedViews ({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    }
  },
  modules: {},
  getters: {
    getRootInfo (state) {
      return state.root
    },
    getUserName (state) {
      return state.userInfo.userName || ''
    }
  }
})
